module.exports = "/_next/static/images/complaint-web-fbf27d34b3340c757e9a776bc63c3421.png";